import React from 'react';

/* See ../hack.html for explicit references to min-h-1 etc. so tailwindcss watch will generated those styles */

const SurveyFormDivider = ({ height }) => {
  return (
    <div className={`bg-lui-iceberg min-h-${height || 2} max-w-[700px] print:m-auto`}></div>
  );
};

export default SurveyFormDivider;
